import { Dispatch } from 'redux';
import { api } from "../config/api";
import { GetState } from "../config/store";
import { 
    getTermsRequest, 
    getTermsSuccess, 
    getTermsFailure,
    cleanTerms as cleanTermsReducer
} from '../reducers/terms';
import { axiosClient } from '../config/axios';

export const getTerms = () => (dispatch: Dispatch) => _getTerms(dispatch);
const _getTerms = async (dispatch: Dispatch) => {
    try {
        dispatch({type: getTermsRequest});

        const response = await axiosClient.get(`${api.settings}/terms-condition`);

        dispatch({type: getTermsSuccess, payload: response?.data.data?.terms_condition});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({type: getTermsFailure, payload: errorResponse?.code});
    }
};

export const getPublicTerms = () => (dispatch: Dispatch) => _getPublicTerms(dispatch);
const _getPublicTerms = async (dispatch: Dispatch) => {
    try {
        dispatch({type: getTermsRequest});

        const response = await axiosClient.get(`${api.settings}/terms-condition/public`);

        dispatch({type: getTermsSuccess, payload: response?.data?.data?.term_condition});
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({type: getTermsFailure, payload: errorResponse?.code});
    }
};

export const cleanTerms = () => (dispatch: Dispatch) => _cleanTerms(dispatch)
const _cleanTerms = (dispatch: Dispatch) => dispatch({ type: cleanTermsReducer});